import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type { DoctorCrmResponse } from '@/Network/Types/Responses/DoctorCrmResponses'
import type { AddDoctorCrmRequest } from '@/Network/Types/Requests/DoctorCrmRequests'

export default class DoctorsService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/doctors'
  }

  async validateTokenCompanyDoctorInvite(token: string): Promise<any> {
    try {
      return await request.post(this.getCompletePath('/invite-validate-token'), { token })
    } catch (e) {
      throw this.handleError(
        e,
        'Não foi possível validar o convite. O link pode ser inválido ou ter expirado.'
      )
    }
  }

  /**
   * Lista os CRMs do médico (principal primeiro, com `isMain`).
   */
  async getDoctorCrms(doctorId: number): Promise<DoctorCrmResponse[]> {
    try {
      const { data } = await request.get<DoctorCrmResponse[]>(
        this.getCompletePath(`/${doctorId}/crms`)
      )
      return data
    } catch (e) {
      // fallback intencional: a lista de CRMs é complementar ao detalhe do
      // médico, que já exibe o CRM principal (`mainCrm`) em ProfessionalDataPanel.
      // Sem a lista, a seção "CRMs do médico" some e o CRM principal continua
      // visível — a falha não pode derrubar a página inteira do médico.
      console.error('Erro ao listar os CRMs do médico:', e)
      return []
    }
  }

  /**
   * Transfere/adiciona um CRM ao cadastro do médico e retorna a lista
   * atualizada de CRMs. Os 409/400 do backend trazem mensagens orientativas
   * (merge de contas, plantões sobrepostos, situação não-Ativa no CFM), que o
   * `ServiceError` preserva até o `notifyError` do chamador.
   */
  async addDoctorCrm(doctorId: number, payload: AddDoctorCrmRequest): Promise<DoctorCrmResponse[]> {
    try {
      const { data } = await request.post<DoctorCrmResponse[]>(
        this.getCompletePath(`/${doctorId}/crms`),
        payload
      )
      return data
    } catch (e) {
      throw this.handleError(
        e,
        'Não foi possível transferir o CRM para este cadastro. Verifique os dados e tente novamente.'
      )
    }
  }
}
